<h2 mat-dialog-title>Update version alias/tags</h2>
<mat-dialog-content class="dialog-content">
  <mat-form-field appearance="fill">
    <mat-label>Alias</mat-label>
    <input matInput [formControl]="alias" />
  </mat-form-field>

  <mat-divider></mat-divider>

  <app-tag-input [formControl]="tags"></app-tag-input>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="onCancel()">Cancel</button>
  <app-loader-button [loading]="isSaving" type="button" color="primary" (click)="save()">Save All</app-loader-button>
</mat-dialog-actions>
